import * as Yup from "yup";

export const clientSchema = Yup.object().shape({
  full_name: Yup.string()
    .required("Nome completo é obrigatório")
    .test("two-words", "Insira nome e sobrenome", (value) => {
      if (!value) return false; // Já é tratado pelo required, mas previne erros
      return value.trim().split(/\s+/).length >= 2;
    }),
  // cpf: Yup.string()
  //     .transform((value) => value.replace(/\D/g, '')) // remove tudo que não for dígito
  //     .matches(/^\d{11}$/, 'CPF deve conter 11 dígitos')
  //     .nullable(),
  cpf: Yup.string()
    .transform((value) => value.replace(/\D/g, ""))
    .nullable()
    .when([], {
      is: (value: string) => !!value?.trim(),
      then: (schema) =>
        schema.matches(/^\d{11}$/, "CPF deve conter 11 dígitos"),
      otherwise: (schema) => schema.notRequired(),
    }),
  email: Yup.string().email("Email inválido").nullable(),
  phone: Yup.string()
    // .matches(/^\d{10,11}$/, 'Telefone deve conter 10 ou 11 dígitos')
    .required("Telefone é obrigatório"),
  birth_date: Yup.string()
    .nullable()
    .test("is-valid-date", "Data inválida", (value) => {
      if (!value) return true;
      const date = new Date(value);
      return !isNaN(date.getTime());
    })
    .test(
      "is-past-date",
      "Data de nascimento não pode ser no futuro",
      (value) => {
        if (!value) return true;
        const date = new Date(value);
        return date <= new Date();
      },
    ),
  zip_code: Yup.string()
    .nullable()
    .transform((value) => (value ? value.replace(/\D/g, "") : "")),
  street: Yup.string().nullable(),
  address_number: Yup.string().nullable(),
  neighborhood: Yup.string().nullable(),
  city: Yup.string().nullable(),
  country: Yup.string().nullable(),
  state: Yup.string()
    .nullable()
    .test("is-valid-state", "Estado deve conter 2 letras", (value) => {
      if (!value) return true; // se estiver vazio, tudo certo
      return /^[A-Za-z]{2}$/.test(value); // só passa se forem 2 letras
    }),
  complement: Yup.string().nullable(), // opcional
  client_group_id: Yup.number()
    .transform((value, originalValue) => {
      return originalValue === "" || originalValue === null
        ? null
        : Number(originalValue);
    })
    .nullable(),
  password: Yup.string()
    // .min(6, 'Senha deve ter no mínimo 6 caracteres')
    .nullable(),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref("password")], "As senhas devem ser iguais")
    .nullable(),
});
